// extracted by mini-css-extract-plugin
export default {"no_data_title":"no_data_title___XjE0_","container":"container___fpvW4","titleStyle":"titleStyle___vmwcG","contentStyle":"contentStyle___RQMC1","buttonStyle":"buttonStyle___dXSbt"};